<template>
  <div class="mentions-wrapper">
    <div>
      <h3>{{ parseTranslation(NUMBER_OF_MENTIONS) }}</h3>

      <ul class="list-mentions">
        <li>{{ parseTranslation(FEWER) }}</li>

        <li>
          <div :style="{ background: getColor(0) }" class="square"></div>

          <span>{{ minCount }}</span>
        </li>

        <div v-for="(mention, index) in mentionsExtractors" :key="index" class="mentions">
          <li v-if="mention.shouldDisplayMention">
            <div :style="{ background: mention.background }" class="square"></div>

            <span v-if="mention.shouldDisplayMaxCount">{{ maxCount }}</span>
          </li>
        </div>

        <li>{{ parseTranslation(MORE) }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import * as translationWordCloud from './wordCloud.translations'

const { default: translations, ...translationKeys } = translationWordCloud

export default {
  name: 'MentionsWordCloud',

  props: {
    minCount: {
      required: true,
    },

    maxCount: {
      required: true,
    },

    wordsCount: {
      required: true,
    },

    colors: {
      required: true,
    },
  },

  data() {
    return {
      translations,
      ...translationKeys,
    }
  },

  computed: {
    mentionsExtractors() {
      // We are sending the value from 1 to 4 to the getColor function because we receive an array that contains colors with five entries. The first value of the array is not being sent because it is rendered by default.

      const mentionsExtractors = [
        {
          shouldDisplayMention: this.validateMinWordsEntries(2),
          background: this.getColor(1),
          shouldDisplayMaxCount: this.validateEntriesSameWords(2),
        },

        {
          shouldDisplayMention: this.validateMinWordsEntries(3),
          background: this.getColor(2),
          shouldDisplayMaxCount: this.validateEntriesSameWords(3),
        },

        {
          shouldDisplayMention: this.validateMinWordsEntries(4),
          background: this.getColor(3),
          shouldDisplayMaxCount: this.validateEntriesSameWords(4),
        },

        {
          shouldDisplayMention: this.validateMinWordsEntries(5),
          background: this.getColor(4),
          shouldDisplayMaxCount: true,
        },
      ]

      return mentionsExtractors
    },
  },

  methods: {
    validateMinWordsEntries(value) {
      return this.wordsCount >= value && this.maxCount >= value
    },

    validateEntriesSameWords(value) {
      return this.wordsCount === value || this.maxCount === value
    },

    getColor(value) {
      return this.colors[value]
    },
  },
}
</script>

<style lang="scss" scoped>
.mentions-wrapper {
  display: flex;
  justify-content: center;
  margin: 30px 10px;

  > div {
    border: 1px solid $white;
    border-radius: 2px;
    padding: 10px;

    .light & {
      border-color: rgba(0, 0, 0, 0.2);
    }

    h3 {
      @include tipography(16);
      text-align: center;
      font-weight: bold;
      margin-bottom: 10px;

      .light & {
        color: $gray-2;
      }
    }

    .list-mentions {
      li {
        @include flexAlignCenter;
        flex-direction: column;
        margin-right: 4px;
        position: relative;
        @include tipography(16);

        span {
          @include flexAlignCenter;
          flex-direction: column;
          @include tipography(14);
          margin-top: 5px;
          position: absolute;
          bottom: -25px;

          &::before {
            content: '';
            display: block;
            width: 1px;
            height: 5px;
            background: rgba(0, 0, 0, 0.25);
            position: relative;
            top: 1px;
          }
        }

        .square {
          border-radius: 2px;
        }

        .light & {
          color: $gray-2;

          span {
            color: $gray-2;
          }
        }
      }

      @media (max-width: 430px) {
        flex-direction: column;

        li {
          margin: 0 0 4px 0;

          &:nth-of-type(1) {
            margin-right: 0;
          }

          &:nth-of-type(3) {
            margin-left: 0;
          }

          span {
            display: none;
          }
        }
      }
    }

    ul {
      @include flexAlignCenter;
      list-style: none;
      padding: 10px 10px;
      margin-bottom: 15px;

      li {
        &:nth-of-type(1) {
          margin-right: 15px;
          font-weight: bold;
        }

        &:nth-of-type(2) {
          .square {
            width: 20px;
            height: 20px;
          }

          span {
            bottom: -30px;
            &::before {
              height: 10px;
            }
          }
        }

        &:nth-of-type(3) {
          margin-right: 0;
          margin-left: 15px;
          font-weight: bold;
        }
      }

      .mentions {
        li {
          margin-right: 4px;

          @media (max-width: 430px) {
            margin: 0 0 4px 0;
          }
        }

        &:nth-of-type(1) {
          .square {
            width: 22.5px;
            height: 22.5px;
          }
        }

        &:nth-of-type(2) {
          .square {
            width: 25px;
            height: 25px;
          }
        }

        &:nth-of-type(3) {
          .square {
            width: 27.5px;
            height: 27.5px;
          }
        }

        &:nth-of-type(4) {
          margin-right: 0;
          .square {
            width: 30px;
            height: 30px;
          }
        }
      }
    }
  }
}
</style>
